import * as Yup from "yup";

export const passwordStrengthSchema = () =>
  Yup.string()
    .min(8, "Password must be at least 8 characters")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/,
      "Password must contain at least one uppercase letter, one lowercase letter, one numeric character, and one special character",
    );

export const signInSchema = Yup.object({
  username: Yup.string().trim().required("Username is required"),
  password: Yup.string()
    .trim()
    .min(8, "Password must be at least 8 characters")
    .required("Please enter password"),
});

// export const signUpSchema = Yup.object().shape({
//   firstname: Yup.string().trim().required("First Name is required"),
//   lastname: Yup.string().trim().required("Last Name is required"),
//   username: Yup.string().trim().required("Username is required"),
//   email: Yup.string()
//     .trim()
//     .email("Invalid email address")
//     .required("Email is required"),
// });

export const forgotPasswordEmailSchema = Yup.object({
  email: Yup.string()
    .trim()
    .email("Invalid email address")
    .required("Email is required"),
});

export const forgotPasswordOtpSchema = Yup.object({
  otp: Yup.string()
    .trim()
    .matches(/^\d{6}$/, "Enter the 6 digit code")
    .required("Verification code is required"),
});

export const resetPasswordSchema = Yup.object({
  password: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/,
      "Password must contain at least one uppercase letter, one lowercase letter, one numeric character, and one special character",
    )
    .required("Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), undefined], "Passwords must match")
    .required("Confirm Password is required"),
});

export const signUpSchema = Yup.object().shape({
  firstname: Yup.string().trim().required("First Name is required"),
  lastname: Yup.string().trim().required("Last Name is required"),
  username: Yup.string().trim().required("Username is required"),
  email: Yup.string()
    .trim()
    .email("Invalid email address")
    .required("Email is required"),
  password: passwordStrengthSchema().required("Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), undefined], "Passwords must match")
    .required("Confirm Password is required"),
});

export const changePasswordSchema = Yup.object().shape({
  current_password: Yup.string().required("Current password is required"),
  new_password: passwordStrengthSchema()
    .test(
      "different-from-current",
      "New password must be different from the current password",
      function (value) {
        if (!value) return true;
        return value !== this.parent?.current_password;
      },
    )
    .required("New password is required"),
  confirm_password: Yup.string()
    .oneOf([Yup.ref("new_password"), undefined], "Passwords must match")
    .required("Confirm Password is required"),
});
